import React from "react";
import { useBookingRoutes } from "hooks";
import { NavigationPageItems } from "components";

export const BookingsNavigationPage: React.FC = () => {
  const { BookingNavigationRoot } = useBookingRoutes();
  return <NavigationPageItems navigationRoot={BookingNavigationRoot} />;
};
